import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-garage-developer-guide/ibm-garage-developer-guide/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import Globals from 'gatsby-theme-carbon/src/templates/Globals';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const InlineNotification = makeShortcode("InlineNotification");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`Complete the steps for setting up the ArgoCD tool to support integration with
Artifactory as a Helm repository`}</p>
    </PageDescription>
    <InlineNotification mdxType="InlineNotification">
      <p><strong parentName="p">{`Note`}</strong>{`: An `}<strong parentName="p">{`environment administrator`}</strong>{` performs the steps on this page. See `}<a parentName="p" {...{
          "href": "/dev-guide/admin/plan-installation#roles"
        }}>{`Plan Installation > Roles`}</a>{` for the overview of the roles involved.`}</p>
    </InlineNotification>
    <h2>{`Overview`}</h2>
    <p>{`ArgoCD is the `}<a parentName="p" {...{
        "href": "/dev-guide/tools/continuous-delivery"
      }}><Globals name="env" mdxType="Globals" />{`’s continuous delivery tool`}</a>{`.
Before you can use it as part of the environment, it must first be configured.`}</p>
    <h2>{`Prerequisites`}</h2>
    <p>{`Before setting up ArgoCD, `}<a parentName="p" {...{
        "href": "/dev-guide/admin/artifactory-setup"
      }}>{`set up Artifactory`}</a>{` so that ArgoCD can use it as a Helm repository.`}</p>
    <h2>{`Configuration`}</h2>
    <p>{`Configure ArgoCD to use Artifactory as a Helm repository.`}</p>
    <h3>{`Get the Helm repository location`}</h3>
    <p>{`The Helm repository is in Artifactory. ArgoCD will need the URL to that repository.`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`In the Artifactory console, select the Home page`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`In the Set Me Up section, click on the `}<inlineCode parentName="p">{`generic-local`}</inlineCode>{` repository`}</p>
        <span parentName="li" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "460px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "51.041666666666664%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABBklEQVQoz6WS6WrDMBCE/f4vVnq4N01bnEJ/2PiMZVmWLB+aajchJCXUIV34vJKQZmdZB1prKKUYWltrL2IYBn4fdF2HJEkQxzHyPMd/whiDgD7TNHGFU4zjiHmeF3HOgcx5Qc0Hfd/vIeuUqRhBl5egYEEhJWohUFUVt1yWJVMUBaq69sJ2L/wXZEB6raCJ3tG8hNi8PiK7v0H5dIf84RZpeI0ivIKRDYy1Zwm2bYugXT2jylJsRINm55asc2QxnBSghs5pmadsohX69QeEd6q+PtH6tfleA0UKF735W2orvnt0Ko4ErfZujKfX2+yHBH/mlOT9OQM5FvS/Blf5BQ7ykrtDwR8yIAuQPuknQQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Set Me Up - Repositories",
            "title": "Set Me Up: Repositories",
            "src": "/dev-guide/static/47a18ca9bf4f3a6f6626bd91afc5df8b/37e4f/setupartifactory.png",
            "srcSet": ["/dev-guide/static/47a18ca9bf4f3a6f6626bd91afc5df8b/7fc1e/setupartifactory.png 288w", "/dev-guide/static/47a18ca9bf4f3a6f6626bd91afc5df8b/37e4f/setupartifactory.png 460w"],
            "sizes": "(max-width: 460px) 100vw, 460px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </li>
      <li parentName="ol">
        <p parentName="li">{`In the Set Me Up dialog for the generic-local repository, copy the Deploy URL`}</p>
        <span parentName="li" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "874px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "67.3611111111111%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsTAAALEwEAmpwYAAABuklEQVQ4y51TbW/TMBD2//9NfEbaFxAbYqKiHaHpVnvN4jhxHDt2Hu6cJrQFIYGjR3c+ny/38lhIKVEUBZRSsNai67r/RtM0EKyM47gixrji1n7rs+xDCKsunHOYpiljWZf65WI7X+77PsN7T0ECIgVKKWUfwQfsxIYl8N/A/lwVS77jhoDTm0bbtvlcDG5Aimn9w58yzPtzwLVswkR3Aknbu5xtDth0DdqhzQ4z4oVOpVCvzvFm4Bq3S5jWwHqHgS57RhxJD3DUhoGbPS2Zn0OkSCLOMo0zyMeTLw9KsDJqDb19gtptUD19g9p+hSEqVbst3vbfUX34BPnuPV7uPkJ+foS8/4LTwwb6cYfqfgO/LzGmuTIK6BENcah4gf5xRM0ojjB7SXsJU7JUqHdkO1XoHA2F+DrQMMZAPfSRkoznXlPJtamhB/NbX1LW5+9flrC9JQpYGrtB02kYGpJua8qihdYWdW2ha+KdjfSSIvkuYGb84i/zmeknApUc/AT16nBQBs+qQykNXk8O5SHg8DxiX4ZZJ7skzh2rBo3xV2NeeCr4/TIHeUIpTjMnScbMzXiFabrG5TNd8BMfR/UG6WCFhwAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Set Me Up - Generic Local Repository",
            "title": "Set Me Up: generic-local Repository",
            "src": "/dev-guide/static/51505acc18d12f318b340646f7d037e7/43104/artifactoryurlsetup.png",
            "srcSet": ["/dev-guide/static/51505acc18d12f318b340646f7d037e7/7fc1e/artifactoryurlsetup.png 288w", "/dev-guide/static/51505acc18d12f318b340646f7d037e7/a5df1/artifactoryurlsetup.png 576w", "/dev-guide/static/51505acc18d12f318b340646f7d037e7/43104/artifactoryurlsetup.png 874w"],
            "sizes": "(max-width: 874px) 100vw, 874px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </li>
    </ol>
    <h3>{`Register the helm repository with ArgoCD`}</h3>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Log in to ArgoCD`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Open the `}<inlineCode parentName="p">{`Settings`}</inlineCode>{` dialog by clicking the `}<inlineCode parentName="p">{`Manage your repositories, projects, settings`}</inlineCode>{` button on the left menu`}</p>
        <span parentName="li" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "838px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "94.44444444444444%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAACQjC21AAAACXBIWXMAABYlAAAWJQFJUiTwAAACAElEQVQ4y62U22/SUBzH+x95iVETArhEXZuNUiu66quKWzKzCxe7dmQE52VLBF2ML/rs3+CrPuk2L7sog20aB7KVUq6CIIGvp91iMiThYeckn/x6fmk/+f7OScqwghu8yEOeCaNRbyCzqyGr51AoltBqtdBut63aidnvtpiIPIG30SlMxxbQrNdhGHkUiaxaraLXMqWdMLcG+vBiyI6AoqLeaOLD2gZW4pv4uJ6wakbT8elLAsurcYulla9YT2zjT7O5n75T6OJYsOfsmJ+bw+s37zCiPIQ6/xz+2Sfw3Ysh9vIVAvefYurRMwQfLFhMRqLQdKP7yA6nE8dOnISiqshXanhPEiyRlIurG/gc30JqT8cySWv2zLpIUq4lv6P0q4Zy7TfK1cMwTl6A7cxpjPkCSOcr+JHNY0cvEIrkuYBvu7mDfeFQfzOdRTKt/Qcjekdw/YoHAVlBKldCMrVHXtb2+ZnFFuHf/gCzt53Ru8I4XW7YbDaMBWWkjXLPD3rBXLOfhevUccz6J5EyKkcXegf7cVm8hKhvnE7CG+x5DFy8gMf+CTrCq312DJKRw3eDdEa+OTyMcZ8fcmjGuuUjC297vbgzOopp8nPYoSHkOA4OhwOyGiIjUzhDQRDAsv1QrJEpCCVJgiQN0RN6PB64ed46QypCURTBsSxC4QiVW/4LIv0bnshy1ogAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "ArgoCD - Settings",
            "title": "ArgoCD settings",
            "src": "/dev-guide/static/077f9a8689787530bef9d06c0a57517e/ade3b/argocd-settings.png",
            "srcSet": ["/dev-guide/static/077f9a8689787530bef9d06c0a57517e/7fc1e/argocd-settings.png 288w", "/dev-guide/static/077f9a8689787530bef9d06c0a57517e/a5df1/argocd-settings.png 576w", "/dev-guide/static/077f9a8689787530bef9d06c0a57517e/ade3b/argocd-settings.png 838w"],
            "sizes": "(max-width: 838px) 100vw, 838px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </li>
      <li parentName="ol">
        <p parentName="li">{`From the Settings page, select `}<inlineCode parentName="p">{`Repositories`}</inlineCode></p>
        <span parentName="li" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "51.041666666666664%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAABYlAAAWJQFJUiTwAAAA4ElEQVQoz52RwW7DIBBE+f/PjNQkBQfbi5e1DdV0cF21OcXO4Wk4LMMDnL/dcAkdfOxhSbCqolpGycSOUbdZQw4e7nH/hIQA6TqMTI0RNgzIfU/inq/4mRPPwpAUl0HQMZdlRbYZSmauS6lYSznGWqDzAhdlQtIMmTLTIFyPk2LKBmsHcOgoba/zLLyS1m47K81K/dryDGq7YWuW3VJo1658xuzP0PiGLPxohr/v1sxqPW33ZDj+e8N3zJ4MO1Hc+cOJ7ZV2pdb3oGErdWFIeNCyT+1nZ0y8+pZn2PcM7PgGMvgJiwjB97QAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "ArgoCD - Repositories",
            "title": "ArgoCD repositories",
            "src": "/dev-guide/static/3938237953854d4f3b92d2e706115245/3cbba/argocd-repositories.png",
            "srcSet": ["/dev-guide/static/3938237953854d4f3b92d2e706115245/7fc1e/argocd-repositories.png 288w", "/dev-guide/static/3938237953854d4f3b92d2e706115245/a5df1/argocd-repositories.png 576w", "/dev-guide/static/3938237953854d4f3b92d2e706115245/3cbba/argocd-repositories.png 1152w", "/dev-guide/static/3938237953854d4f3b92d2e706115245/0b124/argocd-repositories.png 1728w", "/dev-guide/static/3938237953854d4f3b92d2e706115245/981e3/argocd-repositories.png 2098w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Press the `}<inlineCode parentName="p">{`Connect repo using https`}</inlineCode>{` button at the top of the page`}</p>
        <span parentName="li" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "50.69444444444444%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAABYlAAAWJQFJUiTwAAABXklEQVQoz5WTbU+CYBSG+f+/o610li5Ec1haqb35noDIO6KCoq4Xqw/p3XkonetLxHZx7h2eXTsHBpcv1ZDgRSSFIk5y5xDSp0geppA6OkaCKp8gCiUcpPOod2Ww63O9xmaziTKr+3CKPYJseRGKRVk1oCga5D7BqjKgvgeJGAwnGE4XGM6WsP0QuhfADebUW8JlfYIzJyGsH6Lsz2H6C2L+nQOWWT+EMZ5BH03RMz3cSzoeNQcPkgHV9aO+RnAsxGUrbComJuESTy8raO4YnYFDw8yi5xy7/cW+UKM1m30Tz69vWL1/wCVRS7V352IJf0s7tGqLpOYooJV1KPYYZlzhVrIvZUj0Htu0at8Z7yaPPeFW4tLXZYKOZqNL9Aw3oq1a0TmHfeW4E7J61eghU6wgdVZGRrxGtnQTZQZ/UUNd1v8nFGsN8PQjCOVbCJd3KFTryFLOUU6LFVTbMr4AhFLP3V7IisgAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "ArgoCD - New Repository",
            "title": "ArgoCD new repository",
            "src": "/dev-guide/static/f49df0ba10aae51340e90aafb2dd4b30/3cbba/argocd-repository-new.png",
            "srcSet": ["/dev-guide/static/f49df0ba10aae51340e90aafb2dd4b30/7fc1e/argocd-repository-new.png 288w", "/dev-guide/static/f49df0ba10aae51340e90aafb2dd4b30/a5df1/argocd-repository-new.png 576w", "/dev-guide/static/f49df0ba10aae51340e90aafb2dd4b30/3cbba/argocd-repository-new.png 1152w", "/dev-guide/static/f49df0ba10aae51340e90aafb2dd4b30/0b124/argocd-repository-new.png 1728w", "/dev-guide/static/f49df0ba10aae51340e90aafb2dd4b30/657a3/argocd-repository-new.png 2004w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </li>
      <li parentName="ol">
        <p parentName="li">{`In the New Repository dialog, select `}<inlineCode parentName="p">{`helm`}</inlineCode>{` for the repository type, provide a name to identify the
repository, and enter the Artifactory deploy url for the repository url. Press `}<inlineCode parentName="p">{`Connect`}</inlineCode>{` to create the
repository.
`}<span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "51.388888888888886%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAyklEQVQoz6WSOw/CMAyE8///EgMSYkAMhakDCFiakuZh90VhO5xIhQmppcMnL/bpfLY65Cds9sfEepdhtd0jy8/QdQvfdKC2n0yQfmWogQk1DH1phhfqxxPcDyCBJ/OEctcLuNQgXSRY60+djvSXJfh2hboXGq6y4EAgH76EGaR+mbcOqrBeVmZQNyC0D4TuT2Q2aqjCWFjJbQyV/mScVY6b5DDWORf9RRKs5Mpe3mR0uQRVybqlCzCeP6KLHEbVKBSd+roDS8BLeAMO9PYBTt+9NAAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "ArgoCD - New helm repository",
              "title": "ArgoCD helm repository",
              "src": "/dev-guide/static/2144157b5606430021f7d00d7819a1b5/3cbba/argocd-repository-helm.png",
              "srcSet": ["/dev-guide/static/2144157b5606430021f7d00d7819a1b5/7fc1e/argocd-repository-helm.png 288w", "/dev-guide/static/2144157b5606430021f7d00d7819a1b5/a5df1/argocd-repository-helm.png 576w", "/dev-guide/static/2144157b5606430021f7d00d7819a1b5/3cbba/argocd-repository-helm.png 1152w", "/dev-guide/static/2144157b5606430021f7d00d7819a1b5/0b124/argocd-repository-helm.png 1728w", "/dev-guide/static/2144157b5606430021f7d00d7819a1b5/4ea69/argocd-repository-helm.png 2304w", "/dev-guide/static/2144157b5606430021f7d00d7819a1b5/e60a9/argocd-repository-helm.png 2540w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`The repository should now appear and the list and can be used for application deployments`}</p>
      </li>
    </ol>
    <h2>{`Conclusion`}</h2>
    <p>{`ArgoCD now has the configuration in the `}<Globals name="env" mdxType="Globals" />{` that it needs to access the helm chart repository
in Artifactory.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      